module.exports = __webpack_public_path__ + "static/img/link.83161b36.svg";